import { render, staticRenderFns } from "./EmResource.vue?vue&type=template&id=3ce05df4&scoped=true&"
import script from "./EmResource.vue?vue&type=script&lang=js&"
export * from "./EmResource.vue?vue&type=script&lang=js&"
import style0 from "./EmResource.vue?vue&type=style&index=0&id=3ce05df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce05df4",
  null
  
)

component.options.__file = "EmResource.vue"
export default component.exports